import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

export const RegisterMembershipInputSchema = z.object({
  code: z.string().nonempty(),
  participate: z.boolean(),
});

export type RegisterMembershipInput = z.infer<typeof RegisterMembershipInputSchema>;

export const registerMembershipInvitation = async ({ data }: { data: RegisterMembershipInput }): Promise<void> => {
  return (await api.post(`/memberships/register`, data)).data;
};

type RegisterMembershipOptions = {
  mutationConfig?: MutationConfig<typeof registerMembershipInvitation>;
};

export const useRegisterMembership = ({ mutationConfig }: RegisterMembershipOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: registerMembershipInvitation,
  });
};
